import React from 'react';

import { createStyles, Grid, Theme, withStyles, WithStyles } from '@material-ui/core';
import { Appointment } from 'requests/resources/appointment';

import { CardAppointmentStatus } from 'components/v2';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    container: {
      marginBottom: unit,
      marginLeft: unit * 4,
      maxWidth: '264px',
    },
  });

export interface MessageBookStatusProps extends WithStyles<typeof styles> {
  appointment: Appointment;
}

const MessageBookStatus: React.FC<MessageBookStatusProps> = ({ appointment, classes }) => (
  <Grid container className={classes.container}>
    <CardAppointmentStatus appointment={appointment} compact />
  </Grid>
);

export default withStyles(styles, { name: 'MessageBookStatus' })(MessageBookStatus);
